module.exports = __webpack_public_path__ + "media/bg.bfc78615.mp3";